import { defineComponent as _defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { flipOrder, getOrder } from "@/utils/utils";
const linkClass = '!text-gray-900 font-medium inline-flex justify-center items-center gap-x-1 rounded-md bg-white px-2.5 py-1.5 text-sm text-gray-600 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ArticlesOrder',
    setup(__props, { expose: __expose }) {
        __expose();
        const { t: $t } = useI18n();
        const route = useRoute();
        const __returned__ = { $t, route, linkClass, get flipOrder() { return flipOrder; }, get getOrder() { return getOrder; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
